import { useState } from 'react'

import { CloudDownloadOutlined } from '@ant-design/icons'
import { Button } from 'antd'

import { downloadFileApi } from '@eastcoal/api/nexus/oss/downloadFile'

import { useFeedback } from '../../hooks/useFeedback'
import { downloadContent } from '../../utils/filesaver'

import { PreviewItem } from './interface'

export const PreviewFileDownloadButton = ({ file }: { file?: PreviewItem }) => {
  const { message } = useFeedback()
  const [loading, setLoading] = useState(false)

  const downloadFile = async () => {
    try {
      if (!file) {
        message.warning('文件不存在无法下载')
        return
      }
      setLoading(true)
      const res = await downloadFileApi({ ossId: file.ossId })
      downloadContent(res, file.name)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      icon={<CloudDownloadOutlined />}
      loading={loading}
      shape='round'
      size='small'
      type='default'
      onClick={downloadFile}
    >
      下载
    </Button>
  )
}
